// One-line, dismissible definition shown the first time a member sees a
// given block. All tip text comes verbatim from canon/11 section 10 (the
// copy deck). Dismissal is persisted on the member file (see
// /api/dashboard/dismiss-tip), so a tip never resurfaces once closed.
export default function SpineTip({ tipId, text, dismissedTips, onDismiss, tour }) {
  if (!tipId || dismissedTips.includes(tipId)) return null;
  return (
    <div className={tour ? "spine-tip spine-tip-tour" : "spine-tip"}>
      <span>{text}</span>
      <button type="button" className="spine-tip-dismiss" onClick={() => onDismiss(tipId)}>
        Got it
      </button>
    </div>
  );
}
